





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { IExternalAccount, IGroup } from '@/api/types';
import { listGroups } from '@/api/users';
import { formatApiError } from '@/utils/index';

type HeaderType = {
  text: string;
  value: string;
};

type WithGroupName = {
  groupName: string;
};

@Component({
  name: 'AccountListResult',
})
export default class extends Vue {
  @Prop({ required: true }) accounts!: IExternalAccount[];
  @Prop({ required: true }) groups!: IGroup[];
  private groupMap: Map<string, IGroup> = new Map();
  private items: (IExternalAccount & WithGroupName)[] = [];
  private headers: HeaderType[] = [];
  private loading = true;
  private filterText = '';

  mounted() {
    this.loadGroupsMap();
    this.loadItems();
    this.loadHeaders();
    this.loading = false;
  }

  private loadGroupsMap() {
    this.groupMap = new Map(this.groups.map(g => [g.id!, g]));
  }

  private loadItems() {
    this.items = JSON.parse(JSON.stringify(this.accounts));
    this.items.forEach(i => {
      i.groupName = this.groupMap.has(i.groupId)
        ? this.groupMap.get(i.groupId)!.name
        : '';
    });
  }

  private loadHeaders() {
    const id: HeaderType = {
      text: this.$t('{msg} Id', { msg: this.$t('Account') }) as string,
      value: 'id',
    };
    const username: HeaderType = {
      text: this.$t('Username') as string,
      value: 'username',
    };
    const fullName: HeaderType = {
      text: this.$t('Full name') as string,
      value: 'fullName',
    };
    const language: HeaderType = {
      text: this.$t('Language') as string,
      value: 'language',
    };
    const country: HeaderType = {
      text: this.$t('Country') as string,
      value: 'country',
    };
    const group: HeaderType = {
      text: this.$t('Group') as string,
      value: 'group',
    };
    const isInactive: HeaderType = {
      text: `${this.$t('Active')}/${this.$t('Inactive')}`,
      value: 'isInactive',
    };
    const operations: HeaderType = {
      text: this.$t('Operations') as string,
      value: 'operations',
    };
    const headers: HeaderType[] = [
      username,
      fullName,
      language,
      country,
      group,
      isInactive,
      operations,
    ];
    this.headers = headers;
  }

  private getIsInactiveText(isInactive: boolean) {
    return isInactive ? this.$t('Inactive') : this.$t('Active');
  }

  private navigateWithAccount(account: IExternalAccount) {
    this.$router.push({
      name: 'account-detail',
      params: {
        id: account.id!,
      },
    });
  }
}
